<template>
  <div>
    <b-button @click="goBackSubskripsi()" sm="6" variant="primary" class="mb-3">
      <font-awesome-icon icon="arrow-left" transform="shrink-2" class="text-white" /> Kembali ke Halaman Subskripsi
    </b-button>
    <div class="card" style="border-radius: 0px; align-content: center; align-items: center;">
      <template v-if="dataPaygetDetail.detail.status_billing === 'LUNAS'">
        <b-row>
          <b-col sm="12" class="a">
            <div>
              <b-button @click="downloadInvoice(dataPaygetDetail.detail.billing_id)" variant="success" size="sm"
                class="text-capitalize mr-2 btn-block mt-3">DOWNLOAD INVOICE</b-button>
            </div>
          </b-col>
        </b-row>
      </template>

      <div class="card-body">
        <b-row>
          <b-col sm="7" style="text-align: left;" class="mt-1">
            <img fluid :src="require('@/assets/izidok.png')" height="40" width="120">
            <p class="ml-2 mt-5"><strong>{{ dataPaygetDetail.dokter.nama}}</strong></p>
            <p class="ml-2 "><strong>No. Handphone : {{ dataPaygetDetail.dokter.nomor_telp}}</strong></p>
            <p class="ml-2 "><strong>{{ dataPaygetDetail.dokter.email}}</strong></p>
          </b-col>
          <b-col sm="5" style="text-align: left; text-align:left; " class="mt-xl-2">
            <span class="h4"><strong>INVOICE</strong></span>
            <p class=" mt-5"><strong>No. Invoice : {{ dataPaygetDetail.detail.transactionNo}}</strong></p>
            <p class=" "><strong>Tanggal Pembelian :
                {{ convertDateWithoutTime(dataPaygetDetail.detail.transactionDate)}}</strong></p>
            <p class=" "><strong>Tanggal Maksimal Pembayaran :
                {{ dataPaygetDetail.detail.transactionExpire == null ? '-' : convertDate( dataPaygetDetail.detail.transactionExpire)}}</strong></p>
            <p class=" "><strong>Metode Pembayaran : {{ dataPaygetDetail.detail.pg_id == null ? '-' : dataPaygetDetail.paygate.nama}}</strong></p>
            <template v-if="dataPaygetDetail.detail.status_billing === 'LUNAS'">
              <p class=" "><strong>Status Pembayaran : <label class=""
                  style="padding:5px;">LUNAS</label></strong> </p>
            </template>
            <template v-else>
              <p class=" "><strong>Status Pembayaran :</strong> <label class="btn-danger" style="padding:5px;">MENUNGGU
                  PEMBAYARAN</label></p>
            </template>
          </b-col>
          <b-col sm="12" style="text-align: left; text-align:left; " class="mt-xl-2">
            <strong>Kode Promo :
              {{dataPaygetDetail.detail.kode_promo == null ? '-' : dataPaygetDetail.detail.kode_promo}}</strong>
            <div class="table-responsive-xs mt-2">
              <table class="table  mb-0">
                <thead class="thead-dark">
                  <tr class="text-capitalize">
                    <th scope="col">Nama Paket</th>
                    <th scope="col" class="text-center">QTY</th>
                    <th scope="col" class="text-right">Harga Unit</th>
                    <th scope="col" class="text-right">Diskon/Item</th>
                    <th scope="col" class="text-right">Jumlah (Rp)</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="dataPaygetDetail.detail.status_billing === 'LUNAS'">
                    <img src="@/assets/img/lunas.png" class="status-payment">
                  </template>

                  <template v-else>
                    <img src="@/assets/img/BELUM.png" class="status-payment">
                  </template>
                  <tr v-for="(item, index) in dataPaygetDetail.detail.items" :key="index">
                    <template v-if="item.quantity != null">
                      
                      <td class="tx-nowrap" v-html="item.nama"></td>
                      <td class="text-center"> {{item.addson ? '1' : item.quantity}}</td>
                      <td class="text-right" v-if="!item.addson">Rp.
                        {{item.harga.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-
                      </td>
                      <!-- kalau ada addson -->
                      <td class="text-right" v-else>
                        Rp.
                        {{(totalAddson).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-
                      </td>
                      <!-- diskon -->
                      <td class="text-right">
                        <template v-if="item.diskon != null">
                          <template v-if="item.satuan_promo == 'percent'">
                            {{item.diskon}}%
                          </template>  
                          <template v-else-if="item.satuan_promo == 'rupiah'">
                            Rp. {{item.diskon.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-
                          </template>
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <!-- hitung jumlah paket -->
                      <td class="text-right" v-if="!item.addson">
                        <!-- <template v-if="item.satuan_promo == 'percent'">
                          Rp.
                          {{((item.harga * item.quantity) * item.diskon/100) == (item.harga * item.quantity) ? '0' : ((item.harga * item.quantity) * item.diskon/100).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                        </template>
                        <template v-else-if="item.satuan_promo == 'rupiah'">
                          Rp.
                          {{parseInt(item.diskon).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                        </template> -->
                        <!-- tidak ada diskon -->
                        <!-- <template v-else> -->
                          Rp.
                          {{(item.amount_pay).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                        <!-- </template> -->
                      </td>
                      <!-- hitung jumlah addson -->
                      <!-- hitung diskon paket -->
                      <td class="text-right" v-else>
                        <template v-if="item.satuan_promo == 'percent'">
                          Rp. 
                          {{(totalAddson * item.diskon/100) == (totalAddson) ? '0' : (totalAddson * item.diskon/100).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                        </template>
                        <template v-else-if="item.satuan_promo == 'rupiah'">
                          Rp.
                          {{((totalAddson) - item.diskon).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                        </template>
                        <template v-else>
                          Rp.
                          {{((totalAddson) * 1).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                        </template>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
          <b-col sm="8">
          </b-col>
          <b-col sm="4" class="mt-3">
            <b-row>
              <!-- biaya Subtotal -->
              <b-col sm="7" class="mt-3">
                <strong>Subtotal (Rp)
                </strong>
              </b-col>
              <b-col sm="1" class="mt-3 p-0">
                :
              </b-col>
              <b-col sm="4" class="mt-3 p-0">
                <strong> Rp. 
                  {{this.subTotal == 0 ? '0' : this.subTotal.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-
                  </strong>
              </b-col>
              <!-- end biaya subtotal -->
               
              <!-- potongan -->
              <!-- <template v-if="dataPaygetDetail.detail.satuan_promo == 'rupiah'">
                <b-col sm="7" class="mt-3">
                  <strong>Diskon Subtotal </strong>
                </b-col>
                <b-col sm="1" class="mt-3 p-0">
                  :
                </b-col>
                <b-col sm="4" class="mt-3 p-0">
                  <strong>Rp. {{dataPaygetDetail.detail.diskon.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-</strong>
                </b-col>
              </template>
              <template v-else-if="dataPaygetDetail.detail.satuan_promo == 'percent'">
                <b-col sm="7" class="mt-3">
                  <strong>Diskon Subtotal</strong>
                </b-col>
                <b-col sm="1" class="mt-3 p-0">
                  :
                </b-col>
                <b-col sm="4" class="mt-3 p-0">
                  <strong>{{dataPaygetDetail.detail.diskon}}%</strong>
                </b-col>
              </template>
              <template v-else>
                <b-col sm="7" class="mt-3">
                  <strong>Diskon Subtotal</strong>
                </b-col>
                <b-col sm="1" class="mt-3 p-0">
                  :
                </b-col>
                <b-col sm="4" class="mt-3 p-0">
                  <strong>-</strong>
                </b-col>
              </template> -->
              <!-- end potongan -->
              <!-- biaya admin -->
              <b-col sm="7" class="mt-3">
                <strong>Biaya Admin </strong>
              </b-col>
              <b-col sm="1" class="mt-3 p-0">
                :
              </b-col>
              <b-col sm="4" class="mt-3 p-0 ">
                <strong>Rp.
                  {{dataPaygetDetail.detail.pg_id == null ? '0' : dataPaygetDetail.paygate.biaya_admin.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-
                  </strong>
              </b-col>
              <!-- end biaya admin -->
              <!-- total -->
              <b-col sm="7" class="mt-3">
                <strong>Total</strong>
              </b-col>
              <b-col sm="1" class="mt-3 p-0">
                :</b-col>
              <b-col sm="4" class="mt-3 p-0"> <strong>Rp.
                  {{dataPaygetDetail.detail.amount_pay == 0 ? 0 : (dataPaygetDetail.detail.amount_pay).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-</strong>
              </b-col>
              <!-- end total -->
            </b-row>
          </b-col>
        </b-row>
        <b-col sm="12" style="text-align: right; text-align:right; margin-top: 200px; ">
          <label><strong>customercare@izidok.co.id, contact center : 021-723-7982</strong></label>
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  moment.locale('id');
  
  import {
    library
  } from "@fortawesome/fontawesome-svg-core";
  import {
    faHome,
    faUser,
    faSearch,
    faArrowRight,
    faArrowLeft,
    faArrowUp,
    faCheck,
    faCheckCircle
  } from "@fortawesome/free-solid-svg-icons";
  import {
    FontAwesomeLayers
  } from "@fortawesome/vue-fontawesome";
  import {
        mapMutations, mapGetters
    } from "vuex";

  library.add(
    faHome,
    faArrowRight,
    faArrowLeft,
    faArrowUp,
    faUser,
    faSearch,
    faCheck,
    faCheckCircle
  );
  export default {
    components: {

    },
    data() {
      return {
        data: [],
        dataPaygetDetail: null,
        totalAddson : null,
        subTotal : null,
      }
    },
    mounted() {
      this.getPaygetDetail();
    },
    computed: {
      ...mapGetters(["getKlinikId"]),
    },
    methods: {
      convertDate(val) {
        return moment(val).format('DD MMMM YYYY HH:mm:ss ')
      },
      convertDateWithoutTime(val) {
        return moment(val).format('DD MMMM YYYY')
      },
      goBackSubskripsi() {
        this.$router.push({
          name: "klinik-subskripsi",
        });
      },
      downloadInvoice(id) {
        this.$axios.get(`invoice/${id}/${this.getKlinikId}`, {
            responseType: 'arraybuffer'
          })
          .then(response => {
            let blob = new Blob([response.data], {
              type: 'application/pdf'
            })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'invoice' + id + '.pdf'
            link.click()
          })
      },
      fieldList() {
        const {
          generateFieldList: g,
          setSearchableAndSortableFieldList: s
        } = this;
        return (
          [{
              key: "nama_paket",
              label: "Nama Paket"
            },
            {
              key: "qty",
              label: "QTY"
            },
            {
              key: "harga_unit",
              label: "Harga Unit"
            },
            {
              key: "jumlah",
              label: "Jumlah (Rp)"
            },

          ] |> (z => g({
            field: z
          }))
        );
      },
      async getPaygetDetail() {
        try {
          var isRoute = this.$router.currentRoute.params.bill_id;
          const res = await this.$axios.get(`detailpembayaran/${isRoute}/${this.getKlinikId}`)
          this.dataPaygetDetail = res.data.data;

          // format kode promo merdeka
          let kodePromo = this.dataPaygetDetail.detail.kode_promo;

          if (kodePromo) {
              if (kodePromo.toLowerCase().includes("merdeka")) {
                  kodePromo = "Paket Merdeka " 
              }
          }
          
          this.dataPaygetDetail.detail.items.map(data =>{
            // mempunyai key harga_paket
            if(Object(data).hasOwnProperty('harga_paket')) {
              if (kodePromo) {
                kodePromo += data.nama.match(/\d+/)
                this.dataPaygetDetail.detail.kode_promo = kodePromo
              }
            }

            if(data.addson){
              var result = data.addson.reduce(function(tot, arr) { 
                return tot + arr.harga;
              },0);

              this.totalAddson = result;
            }
          });

            const resultSub = this.dataPaygetDetail.detail.items.reduce((acc, curr) => {
           
              //kasus hitung kalo detail addson
              if(curr.addson){
                 if(curr.satuan_promo == 'percent') {
                    return (acc + this.totalAddson - ((this.totalAddson) * curr.diskon/100));
                 } else if(curr.satuan_promo == 'rupiah'){
                    return (acc + this.totalAddson) - curr.diskon;
                 } else {
                    return acc + this.totalAddson;
                 }
              } 
              else {
                  //kasus hitung paket
                  if(curr.satuan_promo == 'percent') {
                    return (acc + curr.harga - ((acc + curr.harga) * curr.diskon/100))
                  } 
                  else if(curr.satuan_promo == 'rupiah'){
                    return (acc + curr.harga) - curr.diskon;
                  } else {
                    return acc + curr.harga;
                  }
              }
            }, 0);

          this.subTotal = resultSub;

          const {
            success,
            data
          } = res.data.data.detail;
          if (success) {
            const {
              data: tmpData,
              total
            } = data;

            const {
              total: totalEntries,
              to: toPage,
              from: fromPage
            } = tmpData;
            this.data = [
              ...tmpData.map((item, index) => {
                return {
                  nama_paket: item.nama,
                  qty: '1',
                  harga_unit: item.amount_real,
                  jumlah: item.amount_real * 1
                };
              })
            ];
            this.rows = total;
            return this;
          }

        } catch {}
      },
    }
  }
</script>

<style scoped>
  .status-payment {
    position: absolute;
    opacity: 0.3;
    margin-left: 315px;
    margin-right: auto;
  }

  @media only screen and (max-width: 900px) and (min-width:768px) {
    .status-payment {
      margin-left: 130px;
    }
  }

  @media only screen and (max-width: 772px) and (min-width:270px) {
    .status-payment {
      margin-left: 80px;
      margin-top: 35px;
      height: 240px;
      width: 320px;
      /* position: relative; */
    }
  }
</style>